import { Component, input } from '@angular/core';
import { JobModuleTranslationKeys } from '@job-v2/ats-utils';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardTranslateKeys } from '../../utils/dashboard-translate-keys.enum';

@Component({
  imports: [TranslateModule],
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  public readonly JobModuleTranslationKeys = JobModuleTranslationKeys;
  public readonly DashboardTranslateKeys = DashboardTranslateKeys;
  public firstname = input.required<string>();
}
